import Jan20Img from './../assets/Bryce_Jan_2020.jpg'
import Feb20Img from './../assets/Zion_Fed_2020.jpg'
import April20Img from './../assets/BYU_April_2020.jpg'
import Aug20Img from './../assets/Nauvoo_Aug_2020.jpg'
import Dec20Img from './../assets/Provo_Dec_2020.jpg'
import July21Img from './../assets/George_July_2021.jpg'
import June21Img from './../assets/Lafayette_June_2021.jpeg'
import Nov21Img from './../assets/Chicago_Nov_2021.jpg'
import Jan22Img from './../assets/Surf_Jan_2022.jpg'

export const ImageData = [
  {
    image: Jan20Img,
    description: 'Bryce Canyon National Park, Utah, Jan. 2020',
  },
  {
    image: Feb20Img,
    description: 'Zion National Park, Utah, Feb. 2020',
  },
  {
    image: April20Img,
    description: 'Brigham Young University, Utah, Apr. 2020',
  },
  {
    image: Aug20Img,
    description: 'Nauvoo Temple, Illinois, Aug. 2020',
  },
  {
    image: Dec20Img,
    description: 'Provo, Utah, Dec. 2020',
  },
  {
    image: June21Img,
    description: 'West Lafayette, Indiana, Apr. 2021',
  },
  {
    image: July21Img,
    description: 'Red Cliff, Utah, Aug. 2021',
  },
  {
    image: Nov21Img,
    description: 'Chicago, Illinois, Nov. 2021',
  },
  {
    image: Jan22Img,
    description: 'Surfside, Texas, Jan. 2022',
  },
];